import { render, staticRenderFns } from "./HandleAssign.vue?vue&type=template&id=7faf8b66&lang=pug"
import script from "./HandleAssign.vue?vue&type=script&lang=js"
export * from "./HandleAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports